<template>
  <v-app>
    <nav style="z-index: 1000">
      <app-header></app-header>
    </nav>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>

import Header from "@/components/Header";

export default {
  name: 'App',

  components: {
    appHeader: Header
  },

  data: () => ({
    //
  }),
};
</script>
